import client from './client';

export async function scan(body)    { const { data } = await client.post('/api/scan', body);    return data; }
export async function livepob(body) { const { data } = await client.post('/api/livepob', body); return data; }
